<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <router-view />
      <global-stomp-debug-panel v-if="false" />
      <audio
        src="./assets/video/sound_Alarm.mp3"
        controls
        id="music"
        style="display: none"
      ></audio>
    </div>
  </a-config-provider>
</template>
<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
import moment from 'moment';
import { configureGlobalStomp, connectGlobalStomp, disconnectGlobalStomp } from './utils/stomp';
import GlobalStompDebugPanel from './component/common/GlobalStompDebugPanel.vue';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');

const PUBLIC_STOMP_ROUTES = {
  '/login': true,
  '/aiShare': true,
  '/thirdLogin': true,
};

function readCookieJson(cookieName) {
  var name = cookieName + '=';
  var cookieArr = document.cookie.split(';');
  for (var i = 0; i < cookieArr.length; i++) {
    var item = decodeURIComponent(cookieArr[i].trim());
    if (item.indexOf(name) === 0) {
      var rawValue = item.substring(name.length, item.length);
      if (!rawValue) {
        return null;
      }
      try {
        return JSON.parse(rawValue);
      } catch (error) {
        return null;
      }
    }
  }
  return null;
}

export default {
  name: 'App',
  components: {
    GlobalStompDebugPanel,
  },
  data() {
    return {
      locale: zhCN,
      type: {},
      timer: null,
      timerLogin: null,
    };
  },
  watch: {
    '$route.path'() {
      this.syncGlobalStomp('route-change');
    },
    '$store.state.user_info'() {
      this.syncGlobalStomp('user-change');
    },
  },
  computed: {
    isDevelopmentEnv() {
      return process.env.NODE_ENV !== 'production';
    },
    // locale () {
    //   // 原先的en-US改成zh-CN即可
    //   return this.$i18n.getLocaleMessage('zh-CN').antLocale
    // }
  },
  created() {
    this.configureGlobalStompService();
    var param = this.getUserInfoFromCookie();
    this.type = param || {};
    if (param && param.user && this.$route.path != '/login') {
      this.$get(
        '/api/user/' + param.user.id,
        {},
        (res) => {
          if (res.code == 0) {
            this.$store.commit('stateFun', {
              name: 'user_info',
              val: res.data,
            });
          } else {
            // this.$message.error(res.msg);
          }
        },
        (err) => {
          // this.$message.error('服务端发生异常');
        }
      );
    }
    this.syncGlobalStomp('created');
  },
  mounted() {
    history.pushState(null, null, document.URL);
    window.addEventListener('popstate', function() {
      history.pushState(null, null, document.URL);
    });
    this.timer = window.setInterval(() => {
      setTimeout(this.getCheck(), 0);
    }, 60000);
    this.timerLogin = window.setInterval(() => {
      setTimeout(this.getCheckLogin(), 0);
    }, 1000);
    this.syncGlobalStomp('mounted');
  },
  beforeDestroy() {
    disconnectGlobalStomp({
      reason: 'app-before-destroy',
      clearSubscriptions: true,
    });
  },
  methods: {
    getUserInfoFromCookie() {
      return readCookieJson('userInfo');
    },
    isPublicStompRoute(path) {
      return Boolean(PUBLIC_STOMP_ROUTES[path]);
    },
    hasValidStompSession() {
      var userInfo = this.getUserInfoFromCookie();
      return Boolean(userInfo && userInfo.user && userInfo.token);
    },
    configureGlobalStompService() {
      configureGlobalStomp({
        baseUrlProvider: () => this.$store.state.baseUrl || window.location.origin,
        path: '/api/ws/event',
        headersProvider: () => {
          var userInfo = this.getUserInfoFromCookie();
          if (userInfo && userInfo.token) {
            return {
              Authentication: userInfo.token,
            };
          }
          return {};
        },
        stompDebug: false,
        heartbeatOutgoingMs: 5000,
        heartbeatIncomingMs: 5000,
        reconnect: {
          enabled: true,
          initialDelayMs: 1000,
          maxDelayMs: 30000,
          multiplier: 1.8,
          jitterRatio: 0.2,
          maxAttempts: Infinity,
        },
        onError: ({ type, error }) => {
          console.error('[GlobalStompService]', type, error);
        },
      });
    },
    syncGlobalStomp(reason) {
      if (this.hasValidStompSession() && !this.isPublicStompRoute(this.$route.path)) {
        connectGlobalStomp({ reason: reason || 'app-sync' });
        return;
      }

      disconnectGlobalStomp({
        reason: reason || 'app-sync-stop',
        clearSubscriptions: true,
      });
    },
    getCheck() {
		if (this.$route.path == '/aiShare') {
			return
		}
      var that = this;
      //console.log('登录页判断并删除定时器111111',this.type)
      if (this.$route.path != '/login') {
        //console.log('登录页判断并删除定时器22222',this.$route.path)
        this.$get(
          '/api/check',
          {},
          (res) => {
            if (res.code == 1) {
              this.$router.replace({
                name: 'Login',
              });
            }
          },
          (err) => {
            this.$message.error(err.msg);
          }
        );
      }
    },
    getCheckLogin() {
		if (this.$route.path == '/aiShare') {
			return
		}
      if (this.$route.path == '/login') {
        disconnectGlobalStomp({
          reason: 'login-route',
          clearSubscriptions: true,
        });
      }
    },
  },
};
</script>
<style lang="scss">
* {
  margin: 0;
  padding: 0;
}
html,
body {
  width: 100%;
  height: 100%;
  position: relative;
}
#app {
  padding: 0 0;
  margin: 0 0;
  width: 100%;
  min-height: 100%;
}
.el-button {
  font-weight: normal !important;
}
// .tbale tr {
//       height: 50px;
// }
// //去除表格底部左右短线
// #app::v-deep .el-table__fixed::before {
//     display: none;
// }
// #app::v-deep .el-table__fixed-right::before {
//     display: none;
// }

// #app::v-deep .el-table::before {
//     display: none;
// }
// .tbale{
//     min-height: 548px;
//     max-height: 567px;
//     overflow: auto;
//     background: #fff;
//     border: 1px solid #EBEEF5;
//     border-bottom: none;
//     border-radius: 4px;
//     margin-top: 10px;
// }
// .tbale .el-table th > .cell{
//   padding-left: 14px;
//   padding-right: 14px;
// }
// .tbale .el-button--mini{
//     padding: 5px 10px;
// }
// .headNav{
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   height: 50px;
// }
// .headNav .search{
//     width: 260px;
// }
// .headNav .search .el-input__icon {
//     position: relative;
//     width: 30px;
//     height: 30px;
//     top: 3px;
//     cursor: pointer;
//     border-radius: 5px;
//     line-height: 32px;
// }

// .headNav .search .el-input__icon:hover {
//     background: #f2f2f2;
// }
// .headNav .el-button--medium{
//   padding: 10px 15px;
// }

//修改动画的大小  给文字加粗效果
.el-loading-spinner {
  font-size: 50px;
  font-weight: bold;
}
//修改文字的大小
.el-loading-mask .el-loading-spinner .el-loading-text {
  font-size: 18px;
}
</style>
